export const apiSettings = {
    uri: 'https://siitulua.confecamaras.co/librerias/wsRestSII/v1/',
    credentials: {
        "codigoempresa": "36", 
        "usuariows": "liquid", 
        "clavews": "4SMfemB4*"
    }
};